<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="tech-offer-main flex-1">
        <h3>Change Password</h3>
        <p>
          <span class="strong">New Password</span>
        </p>
        <div class="form-inline">
          <div>
            <input v-model="password" type="password" />
          </div>
        </div>
        <p>
          <span class="strong">Confirm Password</span>
        </p>
        <div class="form-inline">
          <div>
            <input v-model="confirmPassword" type="password" />
          </div>
        </div>
        <div class="form-inline tech-offer-btn">
          <button class="submit primary" @click="save">SAVE</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpGet } from "@/http/http";

export default {
  computed: {
    ...mapState(["user"])
  },
  data() {
    return {
      password: null,
      confirmPassword: null
    };
  },
  methods: {
    save() {
      if (!this.password || this.password.length < 8) {
        this.$toasted.global.toast_error({
          message: "please use at least 8 characters for the password"
        });
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.$toasted.global.toast_error({
          message: "passwords are inconsistent"
        });
        return;
      }
      httpGet("change_password", {
        email: this.user.email,
        password: this.password
      }).then(response => {
        if (response.ok) {
          this.password = null;
          this.confirmPassword = null;
          this.$toasted.global.toast_success({ message: "save success" });
        } else {
          this.$toasted.global.toast_error({ message: "save error" });
        }
      });
    }
  }
};
</script>